export interface CharacterCountConfig {
  maxLength?: number;
}

export const getCharacterCountText = (
  currentLength: number,
  maxLength?: number,
  showCount: boolean = true,
): string => {
  if (!showCount || !maxLength) return '';

  return `${currentLength}/${maxLength}`;
};

export const getCharacterCountStatus = (
  currentLength: number,
  maxLength?: number,
): 'normal' | 'warning' | 'error' => {
  if (!maxLength) return 'normal';

  const remaining = maxLength - currentLength;
  const warningThreshold = Math.max(10, maxLength * 0.1);

  if (remaining < 0) return 'error';
  if (remaining <= warningThreshold) return 'warning';
  return 'normal';
};

export const FIELD_LIMITS = {
  TITLE: {
    maxLength: 150,
  },
  SHORT_TITLE: {
    maxLength: 80,
  },
  DESCRIPTION: {
    maxLength: 1000,
  },
  SHORT_DESCRIPTION: {
    maxLength: 500,
  },
  BIO: {
    maxLength: 1000,
  },
  HIGHLIGHT: {
    maxLength: 1000,
  },
  NAME: {
    maxLength: 100,
  },
  URL: {
    maxLength: 160,
  },
  ACHIEVEMENT_TITLE: {
    maxLength: 20,
  },
  ACHIEVEMENT_DESC: {
    maxLength: 80,
  },
  SESSION_NAME: {
    maxLength: 250,
  },
  SESSION_DESC: {
    maxLength: 2000,
  },
  TAGLINE: {
    maxLength: 100,
  },
  BODY_COPY: {
    maxLength: 300,
  },
  SKILL_NAME: {
    maxLength: 40,
  },
  CATEGORY_NAME: {
    maxLength: 40,
  },
  MESSAGE: {
    maxLength: 350,
  },
  BADGE_TITLE: {
    maxLength: 100,
  },
  BADGE_DESC: {
    maxLength: 100,
  },
  MODULE_DESC: {
    maxLength: 680,
  },
  PASSWORD: {
    maxLength: 50,
  },
  ENTERPRISE_NAME: {
    maxLength: 40,
  },
  GROUP_TITLE: {
    maxLength: 100,
  },
  GROUP_SUBTITLE: {
    maxLength: 150,
  },
  // New field types for missing validations
  ADMIN_COMMENT: {
    maxLength: 500,
  },
  LANDING_TITLE: {
    maxLength: 55,
  },
  LANDING_BODY: {
    maxLength: 300,
  },
  CONTENT_TITLE: {
    maxLength: 80,
  },
  CONTENT_BODY: {
    maxLength: 500,
  },
  CTA_TITLE: {
    maxLength: 30,
  },
  CTA_BODY: {
    maxLength: 50,
  },
  BUTTON_TEXT: {
    maxLength: 25,
  },
  GOALS_TITLE: {
    maxLength: 50,
  },
  FORM_TITLE: {
    maxLength: 100,
  },
  FORM_DESCRIPTION: {
    maxLength: 200,
  },
  MEDIA_TITLE: {
    maxLength: 100,
  },
  BANK_NAME: {
    maxLength: 100,
  },
  ACCOUNT_HOLDER: {
    maxLength: 100,
  },
  STATISTICS_TITLE: {
    maxLength: 50,
  },
  STATISTICS_DESC: {
    maxLength: 250,
  },
  SECTION_TITLE: {
    maxLength: 80,
  },
  SECTION_BODY: {
    maxLength: 500,
  },
  USER_BIO: {
    maxLength: 1000,
  },
  SESSION_OUTCOME: {
    maxLength: 250,
  },
  MODULE_NAME: {
    maxLength: 250,
  },
  ADDRESS: {
    maxLength: 250,
  },
} as const;

export const getFieldConfig = (fieldType: keyof typeof FIELD_LIMITS): CharacterCountConfig => ({
  ...FIELD_LIMITS[fieldType],
});
